import { Action } from 'redux';
import { FUTURE } from 'src/modules/common/types/Future';
import { PROFILE_SYNC_PERFORM, PROFILE_SYNC_RESET } from 'src/modules/profile/actions/ProfileActions';
import { ProfileState } from 'src/modules/profile/types/ProfileState';

export function editProfileReducer(state: ProfileState, action: Action): ProfileState {
  if (PROFILE_SYNC_PERFORM.isRequest(action)) {
    return {
      ...state,
      state: FUTURE.pending(),
    };
  }
  if (PROFILE_SYNC_PERFORM.isPending(action)) {
    return {
      ...state,
      state: FUTURE.pending(),
    };
  }
  if (PROFILE_SYNC_PERFORM.isSuccess(action)) {
    return {
      ...state,
      form: action.data,
      state: FUTURE.success(action.data),
    };
  }
  if (PROFILE_SYNC_PERFORM.isFailure(action)) {
    return {
      ...state,
      form: action.meta,
      state: FUTURE.failure(action.data),
    };
  }
  if (PROFILE_SYNC_RESET.is(action)) {
    return {
      ...state,
      state: null,
    };
  }
  return state;
}
